const UPDATE_SDU_SUBSCRIPTION = 'UPDATE_SDU_SUBSCRIPTION';

export { UPDATE_SDU_SUBSCRIPTION };
